export const environment = {
  production: false,
  shipmentApiUrl: 'https://shipment2-api-test.jasfbg.com.pl/api/',
  agenciesApiUrl: 'https://agencies-api-test.jasfbg.com.pl/api/',
  settlementsApiUrl: 'https://settlements-api-test.jasfbg.com.pl/api',
  logisticsDocumentsApiUrl: 'https://logistics-documents-service-integration.jasfbg.com.pl/api/',
  waybillsApiUrl: 'https://api.jasfbg.com.pl:8243/waybills/1.0.0/',
  gatewayUrl: 'https://extranet-is4-gateway-test.jasfbg.com.pl/',
  showNotifications: true,
  showUsers: true,
  authConfig: {
    issuer: 'https://sts-api-test.jasfbg.com.pl',
    redirectUri: window.location.origin + '/login',
    clientId: 'extranet',
    responseType: 'code',
    scope: 'openid profile email extranet_modules_access offline_access',
    showDebugInformation: true,
    postLogoutRedirectUri: window.location.origin + '/login',
    expiredTokenLogoutDelayInMs: 5000
  },
  language: 'pl',
  hj: '2857779',
  ga: 'G-77VPC806K2'
};
